import PageTest from "./page_test.js";

export default class PageTestResult extends PageTest {}
